import { Slide } from '@material-ui/core';
import { NavigatorProvider } from 'provider/Navigator.provider';
import React from 'react';
import { Footer } from './Footer';
import { Header } from './Header';

export const Layout = ({ children }) => {
  return (
    <React.Fragment>
      <NavigatorProvider>
        <Header />
        <Slide direction="up" in mountOnEnter unmountOnExit timeout={2000}>
          <main>{children}</main>
        </Slide>
        <Footer />
      </NavigatorProvider>
    </React.Fragment>
  );
};
